var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'ccos-price',
        {
            'ccos-price--right-aligned': _vm.rightAligned,
            'ccos-price--small': _vm.small,
        } ]},[_c('div',{staticClass:"ccos-price__euros"},[_vm._v(" "+_vm._s(_vm.formattedPrice)+" "),_vm._t("frequency")],2),(_vm.$scopedSlots.default)?_c('div',{staticClass:"ccos-price__sub"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }